import React, {Component} from 'react';
import Card from "../MaintenantCards/Card";
import Mansory from "react-masonry-component";
import {Link} from "react-router-dom";

class Group extends Component {


    render() {
        return (
            <table className="table table-striped">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>Date réunion</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                {this.props.entries.map((entry) => {
                    return (
                        <tr>
                            <td>{entry.id}</td>
                            <td>{entry.fields['Date réunion']}</td>
                            <td>
                                <Link to={"/record/" + entry.id} className="btn btn-primary">
                                    Consulter
                                </Link>
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        );
    }
}

export default Group;


// WEBPACK FOOTER //
// ./src/Components/Reunion/Group.js